import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  discountOnCategoryText: {
    id: 'checkout.cartPage.loyaltyWrapper.discountOnCategory',
    defaultMessage: '<b>Loyalty discount {percent}%</b> on the {listName} category',
  },
  discountOnBrandText: {
    id: 'checkout.cartPage.loyaltyWrapper.discountOnBrand',
    defaultMessage: '<b>Loyalty discount {percent}%</b> on the {listName} brand',
  },
  discountDisabled: {
    id: 'checkout.cartPage.loyaltyWrapper.discountDisabled',
    defaultMessage: 'The discount does not apply to products already discounted using discount codes',
  },
});
